import PropTypes from 'prop-types';
import Modal from "../modal";
import moment from 'moment/min/moment-with-locales';
import 'moment/locale/es'; 

moment.locale('es');

const CitasModal = ({ show, handleshow, Citas }) => {
    return (
      <Modal isOpen={show} onClose={()=>handleshow(false)} title={'Listado de Citas'}>
        <div className="w-[32rem] max-h-[45rem] rounded-lg border border-stone-200 overflow-auto">
           <table className="w-full table-auto">
               <thead className="border-b border-stone-200 text-sm font-medium ">
                 <tr>
                   <th className="px-2.5 py-2 text-start font-medium">Id.</th>
                   <th className="px-2.5 py-2 text-start font-medium">Fecha Cita</th>
                   <th className="px-2.5 py-2 text-start font-medium">Hora</th>
                   <th className="px-2.5 py-2 text-start font-medium">Profesional</th>
                   <th className="px-2.5 py-2 text-start font-medium">Especialidad</th>
                 </tr>
               </thead>
               <tbody className="group text-sm text-stone-800 ">
                 {Citas.map((item) => {
                     return (
                       <tr className="border-b border-stone-200 last:border-0" key={item.CitaId} id={`fila${item.CitaId}`}>
                         <td>
                           <div className="flex items-center gap-3 text-sm text-current">
                             {item.CitaId}
                           </div>
                         </td>
                         <td>{item.FechaCta &&(moment(item.FechaCta).format('DD/MM/YYYY'))}</td>
                         <td>{item.FechaIni &&(moment(item.FechaIni).format('HH:mm'))}</td>
                         <td>{item.Profesional}</td>
                         <td>{item.Especialidad}</td>
                       </tr>
                  )})}
               </tbody>
           </table>
        </div>
      </Modal>     
    );
  };
  CitasModal.propTypes = {
    show: PropTypes.bool.isRequired,
    handleshow: PropTypes.func.isRequired,
    Citas:PropTypes.object
  };
  
export default CitasModal;